import * as React from "react";
import styled from "styled-components";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { FormInput } from "../views/login.form.c";

const Wrapper = styled.div`
	position: relative;
	width: 100%;

	${FormInput} {
		padding-right: 40px;
	}
`;

const ToggleButton = styled.button`
	position: absolute;
	right: 8px;
	top: 50%;
	transform: translateY(-50%);
	background: none;
	border: none;
	cursor: pointer;
	padding: 4px;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #94a3b8;

	&:hover {
		color: #475569;
	}
`;

interface PasswordInputProps {
	id?: string;
	name: string;
	placeholder: string;
	value: string;
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	required?: boolean;
	disabled?: boolean;
	tabIndex?: number;
	autoComplete?: string;
}

export const PasswordInput: React.FC<PasswordInputProps> = ({
	id,
	name,
	placeholder,
	value,
	onChange,
	required,
	disabled,
	tabIndex,
	autoComplete,
}) => {
	const [visible, setVisible] = React.useState(false);
	return (
		<Wrapper>
			<FormInput
				id={id}
				type={visible ? "text" : "password"}
				name={name}
				placeholder={placeholder}
				value={value}
				onChange={onChange}
				required={required}
				disabled={disabled}
				tabIndex={tabIndex}
				autoComplete={autoComplete}
			/>
			<ToggleButton type="button" onClick={() => setVisible(!visible)} tabIndex={-1} aria-label={visible ? "Hide password" : "Show password"}>
				{visible ? <FaEyeSlash size={16} /> : <FaEye size={16} />}
			</ToggleButton>
		</Wrapper>
	);
};
